module.exports = __webpack_public_path__ + "static/img/35.e1d02fc5.png";